import React, { useState } from 'react';
import { Card, Image } from 'react-bootstrap';
import './RacerProfile.css';

const RacerProfile = ({ profile }) => {
  const [imageError, setImageError] = useState(false);

  if (!profile) return null;

  // 選手の画像URL - プロフィール写真はレースサイトから参照
  const imageUrl = `https://www.boatrace.jp/racerphoto/${profile.racer_number}.jpg`;
  
  // デフォルト画像（エラー時）
  const defaultImageUrl = 'https://via.placeholder.com/150x150?text=No+Image';
  
  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div className="racer-profile-container">
      <Card className="racer-profile-card">
        <Card.Body className="p-2 text-center">
          <Image 
            src={imageError ? defaultImageUrl : imageUrl}
            onError={handleImageError}
            alt={profile.name}
            className="racer-photo mb-2"
            fluid
          />
          
          <h5 className="racer-name mb-1">{profile.name}</h5>
          
          <div className="racer-number mb-1">{profile.racer_number}</div>
          
          <div className="racer-details">
            <div className="info-value">{profile.age}歳・{profile.from}</div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default RacerProfile;